import { PluginInterface } from '../../types/PluginInterface';
import { generateUniformPlaceholder } from '../../utils/PlaceholderGenerator';
import { defaultConfig } from './config';
import { RentalConfigComponent } from './components/RentalConfigComponent';
import { RentalPreview } from './components/RentalPreview';
import { RentalConfig } from './types';

const RentalPluginModular: PluginInterface = {
  metadata: {
    id: 'rental-plugin',
    name: 'Location de Vacances',
    version: '2.0.0',
    description: 'Plateforme de location de vacances : villas, maisons, gîtes, chalets. Calendrier, paiement Stripe/PayPal, taxe de séjour, caution, avis voyageurs.',
    author: 'Flexihub Team',
    icon: '🏖️',
    category: 'commerce',
    tags: ['location', 'vacances', 'villa', 'gîte', 'chalet', 'réservation', 'airbnb', 'booking', 'stripe', 'paypal']
  },

  documentationForAI: {
    description: "Plugin de location de vacances avec calendrier de disponibilités, paiement en ligne, taxe de séjour, caution, tarifs saisonniers et avis voyageurs.",
    usage: "Utilise ce plugin pour proposer des biens de vacances (villas, maisons, gîtes, chalets...) avec réservation et paiement intégrés.",
    configSchema: {
      title: "Titre de la section",
      currency: "Devise (EUR, USD...)",
      bookingMode: "'instant' (confirmation auto) ou 'request' (validation manuelle)",
      items: "Liste des biens (nom, catégorie, capacité, équipements, tarifs, photos)",
      depositAmount: "Montant de la caution (0 = désactivée)",
      touristTaxPerPersonPerNight: "Taxe de séjour par personne/nuit",
      enableReviews: "Activer les avis voyageurs",
    },
    exampleConfig: {
      title: "Nos Villas en Guadeloupe",
      currency: "EUR",
      bookingMode: "instant",
      depositAmount: 500,
      touristTaxPerPersonPerNight: 1.5,
      items: [{
        id: "v1",
        name: "Villa Anse des Rochers",
        category: "villa",
        badge: "coup-de-coeur",
        pricePerDay: 350,
        weekendPricePerDay: 420,
        cleaningFee: 80,
        capacity: { guests: 8, bedrooms: 4, beds: 5, bathrooms: 2 },
        amenities: ["wifi", "pool", "ac", "parking", "beach", "sea-view", "bbq"],
        rules: { checkInTime: "15:00", checkOutTime: "10:00", minNights: 3 },
        seasonalPrices: [{ id: "s1", label: "Été 2025", startDate: "2025-07-01", endDate: "2025-08-31", pricePerDay: 520 }],
      }]
    }
  },

  defaultConfig,
  ConfigComponent: RentalConfigComponent,
  PreviewComponent: RentalPreview,

  generateHTML: (config: RentalConfig) => {
    const instanceId = config.id || `rental-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    const configWithId = { ...config, id: instanceId };
    const itemCount = configWithId.items?.length || 0;

    return generateUniformPlaceholder({
      pluginId: instanceId,
      pluginType: 'rental-plugin',
      category: 'commerce',
      title: configWithId.title || 'Location de Vacances',
      description: `🏖️ ${itemCount} bien(s) en location`,
      icon: '🏖️',
      config: configWithId
    });
  },
};

export default RentalPluginModular;
